// extracted by mini-css-extract-plugin
export default {"table":"table_table__ptgj4","modal":"table_modal__tmxhu"};